import axios from "axios"

const controller = "/ordenVenta"

const OrdenVentaService = {
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    registrar: async (request) => {
        const { data } = await axios.post(`${controller}/registrar`, request)
        return data
    },
    adjuntar: async (file, ovt_id, tipo) => {
        let form = new FormData()
        form.append("file", file)
        form.append("ovt_id", ovt_id)
        form.append("tipo", tipo)
        const { data } = await axios.post(`${controller}/adjuntar`, form)
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    modificar: async (request) => {
        const { data } = await axios.post(`${controller}/modificar`, request)
        return data
    },
    aprobar: async (request) => {
        const { data } = await axios.post(`${controller}/aprobar`, request)
        return data
    },
    aprobar: async (request) => {
        const { data } = await axios.post(`${controller}/aprobar`, request)
        return data
    },
    generarComprobante: async (request) => {
        const { data } = await axios.post(`${controller}/generarComprobante`, request)
        return data
    },
}

export default OrdenVentaService